// Stores
import { useResult } from "../../../shared/formContext/hooks/useResult";

// Result Types
import PropertyValuation from "./Result/PropertyValuation";
import Error from "@shared/Error/Error";

// Components
import Empty from "@shared/Empty/Empty";
import Loading from "../../../components/Loading/Loading";
import {__} from "@wordpress/i18n";
const alfredoLogoUrl = `${window.ajaxObject.theme_uri}/assets/media/images/alfredo.png`;

// UI Messages
const UI_MESSAGES = {
    LOADING: "A carregar...",
    ERROR_STATUS: "Ocorreu um erro ao carregar os resultados.",
    NO_RESULTS: "Não há resultados disponíveis no momento.",
    ALFREDO: __("Em parceria com", "df-simulators"),
};

// Constants for result types
const RESULT_TYPES = {
    PropertyValuation: "property_valuation_proptech",
};

const Results = () => {
    const { resultData } = useResult();
    const { response, loading, statusCode } = resultData;

    /**
     * Renders the appropriate result component based on the type and status.
     * @returns {JSX.Element} - Component to be rendered.
     */
    const renderResult = () => {
        // Render loading component if loading and no response yet
        if (loading && !response) {
            return <Loading message={UI_MESSAGES.LOADING} />;
        }

        // Render empty state if there is no response and no previous result
        if (!response) {
            return (
                <div className="hidden lg:flex flex-col gap-12">
                    <Empty message={UI_MESSAGES.NO_RESULTS} />
                </div>
            );
        }

        // Render error component if there is a status code other than 200
        if (statusCode && statusCode !== 200) {
            console.warn(UI_MESSAGES.ERROR_STATUS);
            return <Error />;
        }

        return <PropertyValuation/>;
    };

    return (
        <div className="tool-block__component__results__result">
            {renderResult()}
        </div>
    );
};

export default Results;
